import { Icon, Text } from '@dixa/lib-shared-habla';
import { type FileUIPart } from 'ai';

import { getAttachmentIcon } from '../../../../utils/sidekickAttachments';

import styles from './sidekickAttachmentChip.module.scss';

type SidekickAttachmentChipProps = {
  attachment: FileUIPart;
  onRemove: () => void;
};

export const SidekickAttachmentChip = ({
  attachment,
  onRemove,
}: SidekickAttachmentChipProps): JSX.Element => (
  <div className={styles.chip}>
    <Icon name={getAttachmentIcon(attachment)} size={16} />
    <Text.Paragraph variant="4" className={styles.filename}>
      {attachment.filename}
    </Text.Paragraph>
    <button
      type="button"
      className={styles.remove}
      aria-label={`Remove ${attachment.filename ?? 'attachment'}`}
      onClick={onRemove}
    >
      <Icon name="close" size={16} />
    </button>
  </div>
);
